<script>
    export default {
        name: "SchemaFaq",
        props: {
            items: Array,
        },
        mounted() {
            document.documentElement.setAttribute("itemscope", true);
            document.documentElement.setAttribute("itemtype", "https://schema.org/FAQPage");
        },
        beforeDestroy() {
            document.documentElement.removeAttribute("itemscope");
            document.documentElement.removeAttribute("itemtype");
        },
    };
</script>

<template>
    <div class="schema-faq visually-hidden">
        <div
            v-for="(item, index) in items"
            :key="index"
            itemscope
            itemprop="mainEntity"
            itemtype="https://schema.org/Question"
        >
            <div itemprop="name">{{ item.title }}</div>
            <div itemscope itemprop="acceptedAnswer" itemtype="https://schema.org/Answer">
                <div itemprop="text" v-html="item.desc"></div>
            </div>
        </div>
    </div>
</template>
